import { Request } from 'express';

export class GetOptions {
  public query = '';
  public filter = '';
  public skip = 0;
  public take = 10;
  public sort = '';
  public sortColumn = '';
  public sortAscending = true;

  constructor(currentPage: number = 1, pageSize: number = 10) {
    this.take = pageSize;
    this.skip = (currentPage - 1) * pageSize;
  }

  public static calculatePageCount(rowCount: number, pageSize: number) {
    const pageCount = Math.floor((rowCount - 1) / pageSize) + 1;
    return pageCount;
  }

  public setSort(field: string, ascending: boolean = true) {
    this.sortColumn = field;
    this.sortAscending = ascending;
    if (ascending === true) {
      this.sort = field + ':ASC';
    } else {
      this.sort = field + ':DESC';
    }
  }
}
